//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import * as React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
// import { useTheme } from '@material-ui/core/styles';
// import useMediaQuery from '@material-ui/core/useMediaQuery';
import SimpleBar from 'simplebar-react';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { AppContext, LayoutContext } from '../common/contexts';
import { setClassNameInDefns } from '../definitionHelper';

import JobDetailEmpty from '../../jobCenter/subComponents/JobDetailEmpty';
import JobDetailNotFound from '../../jobCenter/subComponents/JobDetailNotFound';
import JobListingNotAvailableYet from '../../jobCenter/subComponents/JobListingNotAvailableYet';

import JobSeekerProfileEmpty from '../../empTalentCenter/subComponents/JobSeekerProfileEmpty';
import JobSeekerProfileNotFound from '../../empTalentCenter/subComponents/JobSeekerProfileNotFound';
import JobSeekersNotAvailableYet from '../../empTalentCenter/subComponents/JobSeekersNotAvailableYet';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';
import _isNil from 'lodash/isNil';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    const { noPadding } = params;
    return makeStyles(theme => ({
        rootContainer: {
            // border: '1px solid red',
            padding: noPadding ? '0px' : '10px 30px 10px 30px',
        },
        noAdsContainer: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            // textAlign: 'center',
            // width: 'fit-content',
            // marginTop: '10vw',
            // margin: 'auto',
        },
        gridItem: {
            // border: '1px solid green',
            height: '320px',

            [theme.breakpoints.down('sm')]: {
                maxHeight: '200px',
            },
        },
        adImage: {
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            // minHeight: '300px',
            backgroundPosition: 'center',
            borderRadius: '15px',
            height: '-webkit-fill-available',
            cursor: 'pointer',
            border: '1px solid lightgrey',
            background: '#F0F2F6',

            [theme.breakpoints.down('sm')]: {
                maxHeight: '200px',
            },
        },
        searchIcon: {
            fontSize: '20vw',
            margin: 'auto',
            color: '#F0F2F6',
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes } = params;

    const defns = {
        mainGrid: {
            container: true,
            alignItems: 'center',
            justifyContent: 'space-between',
            spacing: 2,
        },
        gridItem: {
            item: true,
            xs: 6,
        },
    };

    // inject classes
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const getJobCenterEmptyPane = (searchResultTotal, isDefaultSearch, singleJobMode) => {
    if (_isNil(searchResultTotal)) {
        return null; //<JobDetailEmpty />;
    } else if (isDefaultSearch && searchResultTotal === 0) {
        return <JobListingNotAvailableYet />;
    } else if (!isDefaultSearch && searchResultTotal === 0) {
        return <JobDetailNotFound singleJobMode />;
    } else {
        return <JobDetailEmpty />;
    }
};

const getTalentCenterEmptyPane = (searchResultTotal, isDefaultSearch) => {
    if (_isNil(searchResultTotal)) {
        return null; //<JobSeekerProfileEmpty />;
    } else if (isDefaultSearch && searchResultTotal === 0) {
        return <JobSeekersNotAvailableYet />;
    } else if (!isDefaultSearch && searchResultTotal === 0) {
        return <JobSeekerProfileNotFound />;
    } else {
        return <JobSeekerProfileEmpty />;
    }
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const AfitdAdContainer = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    // const theme = useTheme();

    // const lgMatches = useMediaQuery(theme.breakpoints.down('lg'));
    // const smMatches = useMediaQuery(theme.breakpoints.down('sm'));

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    // let arr = [
    //     'https://images.unsplash.com/photo-1658741446147-d9e22eea8730?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8fHx8fHx8MTY2MTE1MzIzMQ&ixlib=rb-1.2.1&q=80&w=1080',
    //     'https://images.unsplash.com/photo-1659563116744-cf82e9349d9a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8fHx8fHx8MTY2MTE1MzY5NQ&ixlib=rb-1.2.1&q=80&w=1080',
    //     'https://images.unsplash.com/photo-1659560893497-bb094425bd21?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8fHx8fHx8MTY2MTE1MzcyNw&ixlib=rb-1.2.1&q=80&w=1080',
    //     'https://images.unsplash.com/photo-1660470071057-43890ce5b7be?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8fHx8fHx8MTY2MTE1Mzc0NA&ixlib=rb-1.2.1&q=80&w=1080',
    // ];

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { data, noPadding, searchResultTotal, isJobCenter, isTalentCenter, isDefaultSearch, singleJobMode } = props;

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const classes = useStyles({ noPadding })();
    const defns = getDefns({
        classes,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div style={{ height: '100%' }}>
            {data?.length > 0 ? (
                <SimpleBar style={{ height: '100%' }}>
                    <div {...defns.rootContainer}>
                        <Grid {...defns.mainGrid}>
                            {data.map(el =>
                                el?.imgUrl ? (
                                    <Grid {...defns.gridItem}>
                                        <div {...defns.adImage} style={{ backgroundImage: `URL(${el?.imgUrl})` }}></div>
                                    </Grid>
                                ) : (
                                    <Grid {...defns.gridItem}>
                                        <div {...defns.adImage}></div>
                                    </Grid>
                                ),
                            )}
                        </Grid>
                    </div>
                </SimpleBar>
            ) : isJobCenter ? (
                getJobCenterEmptyPane(searchResultTotal, isDefaultSearch, singleJobMode)
            ) : isTalentCenter ? (
                getTalentCenterEmptyPane(searchResultTotal, isDefaultSearch)
            ) : (
                <SimpleBar style={{ height: '100%' }}>
                    <div {...defns.noAdsContainer}>
                        <SearchRoundedIcon {...defns.searchIcon} />
                    </div>
                </SimpleBar>
            )}
        </div>
    );
};

export default AfitdAdContainer;
